import React from 'react'

import { Body, NotebookShow } from '@components/organisms'

export default function PageShowNotebook() {
	return (
		<Body>
			<NotebookShow />
		</Body>
	)
}
